<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
            name="Add Details"
            bc1="App"
            bc2="Currency"
            bc3="Add"
            path="currency"
          ></Breadcrumb>
        </div>
        <div
          class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none"
        >

        </div>
      </div>
      <div class="content-body">
        <!-- Basic Horizontal form layout section start -->
        <section id="basic-horizontal-layouts">
          <div class="row">
            <div class="col-md-12 col-12">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title">Add Details</h4>
                </div>
                <div class="card-body">
                  <form class="form form-horizontal">
                    <div class="row">
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label for="name-icon">Name</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <div class="input-group-prepend">
                                <span class="input-group-text"
                                  ><i class="far fa-user"></i
                                ></span>
                              </div>
                              <input
                                type="text"
                                v-model="name"
                                id="name-icon"
                                class="form-control"
                                :class="
                                  errorBag.has('name') ? 'is-invalid' : ''
                                "
                                name="name"
                                placeholder="Name"
                                v-validate="'required'"
                              />
                              <small
                                v-show="errorBag.has('name')"
                                class="invalid-feedback"
                                >{{ "*" + errorBag.first("name") }}</small
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label for="symbol-icon">Symbol</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <div class="input-group-prepend">
                                <span class="input-group-text"
                                  ><TargetIcon
                                /></span>
                              </div>
                              <input
                                type="text"
                                v-model="symbol"
                                id="symbol-icon"
                                class="form-control"
                                :class="
                                  errorBag.has('symbol') ? 'is-invalid' : ''
                                "
                                name="symbol"
                                placeholder="Symbol"
                                v-validate="'required'"
                              />
                              <small
                                v-show="errorBag.has('symbol')"
                                class="invalid-feedback"
                                >{{ "*" + errorBag.first("symbol") }}</small
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>File</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <div class="custom-file">
                                <small
                                  v-show="errorBag.has('file')"
                                  class="invalid-feedback"
                                  >{{ "*" + errorBag.first("file") }}</small
                                >
                                <input
                                  type="file"
                                  class="custom-file-input"
                                  :class="
                                    errorBag.has('file') ? 'is-invalid' : ''
                                  "
                                  id="customFile1"
                                  name="file"
                                  @change="onFileChanged"
                                  v-validate="'required'"
                                />
                                <label
                                  class="custom-file-label"
                                  for="customFile1"
                                  >{{
                                    logo ? logo.name : "Choose icon image"
                                  }}</label
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>Type</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <select
                                class="custom-select"
                                name="type"
                                v-model="type"
                                :class="
                                  errorBag.has('type') ? 'is-invalid' : ''
                                "
                                v-validate="'required'"
                              >
                                <option value="">Please select item</option>
                                <option value="fiat">Fiat</option>
                                <option value="crypto">Crypto</option>
                              </select>
                              <small
                                v-show="errorBag.has('type')"
                                class="invalid-feedback"
                                >{{ "*" + errorBag.first("type") }}</small
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>Exchange from</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <select
                                class="custom-select"
                                name="exchangeFrom"
                                v-model="exchangeFrom"
                                :class="
                                  errorBag.has('exchangeFrom')
                                    ? 'is-invalid'
                                    : ''
                                "
                                v-validate="'required'"
                              >
                                <option value="">Please select item</option>
                                <option value="local">Local</option>
                                <option value="api">Api</option>
                              </select>
                              <small
                                v-show="errorBag.has('exchangeFrom')"
                                class="invalid-feedback"
                                >{{
                                  "*" + errorBag.first("exchangeFrom")
                                }}</small
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label for="minorUnit-icon">Minor Unit</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <div class="input-group-prepend">
                                <span class="input-group-text"
                                ><Edit3Icon
                                /></span>
                              </div>
                              <input
                                  type="text"
                                  id="minorUnit-icon"
                                  class="form-control"
                                  v-model="minorUnit"
                                  name="minorUnit"
                                  placeholder="Minor Unit"
                                  :class="
                                  errorBag.has('minorUnit') ? 'is-invalid' : ''
                                "
                                  v-validate="'required'"
                              />
                              <small
                                  v-show="errorBag.has('minorUnit')"
                                  class="invalid-feedback"
                              >{{ "*" + errorBag.first("minorUnit") }}</small
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label for="rate-icon">Rate</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <div class="input-group-prepend">
                                <span class="input-group-text"
                                  ><Edit3Icon
                                /></span>
                              </div>
                              <input
                                type="text"
                                id="rate-icon"
                                class="form-control"
                                v-model="rate"
                                name="rate"
                                placeholder="Rate"
                                :class="
                                  errorBag.has('rate') ? 'is-invalid' : ''
                                "
                                v-validate="'required'"
                              />
                              <small
                                v-show="errorBag.has('rate')"
                                class="invalid-feedback"
                                >{{ "*" + errorBag.first("rate") }}</small
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label for="rate-icon">Code</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <div class="input-group-prepend">
                                <span class="input-group-text"
                                  ><Edit3Icon
                                /></span>
                              </div>
                              <input
                                type="text"
                                id="code-icon"
                                class="form-control"
                                v-model="code"
                                name="code"
                                placeholder="Code"
                                :class="
                                  errorBag.has('code') ? 'is-invalid' : ''
                                "
                                v-validate="'required'"
                              />
                              <small
                                v-show="errorBag.has('code')"
                                class="invalid-feedback"
                                >{{ "*" + errorBag.first("code") }}</small
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-9 offset-sm-3 d-flex">
                        <button
                          type="button"
                          class="btn btn-primary mr-1 d-flex"
                          @click="sendCall"
                          :disabled="loading"
                        >
                          <Loader :loading="loading" :size="size"></Loader>
                          Save
                        </button>
                        <button
                          type="button"
                          class="btn btn-gradient-secondary"
                          @click="$router.push({ name: 'currency' })"
                        >
                          Back
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- Basic Horizontal form layout section end -->
      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>
import { TargetIcon, Edit3Icon, CommandIcon } from "vue-feather-icons";
export default {
  components: {
    TargetIcon,
    Edit3Icon,
    CommandIcon
  },
  mounted() {},
  data() {
    return {
      name: "",
      symbol: "",
      logo: null,
      type: "",
      exchangeFrom: "",
      rate: "",
      minorUnit: "",
      code: "",
      loading: false,
      size: "10px"
    };
  },
  methods: {
    onFileChanged(event) {
      this.logo = event.target.files[0];
    },
    sendCall() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.loading = true;
          var data = {
            name: this.name,
            symbol: this.symbol,
            type: this.type,
            exchangeFrom: this.exchangeFrom,
            rate: this.rate*100,
            minorUnit: this.minorUnit,
            code : this.code,
          }

          let attachment = new FormData();
          attachment.append("logo", this.logo);
          data.hasAttachment = attachment

          this.makeRequest("post", "v1/add-currency", data).then(
            callResponse => {
              if (!callResponse.error) {
                let code = callResponse.response.data.code;
                if (code == 200) {
                  this.loading = false;
                  if (callResponse.response.data.data) {
                    let responseData = callResponse.response.data.data;
                    let storeData = this.$store.getters.getByKey("currency");
                    if (typeof storeData.firstPageData.data != "undefined") {
                      storeData.firstPageData.data.unshift(responseData);
                      storeData.firstPageData.pagination.total = storeData.firstPageData.pagination.total + 1
                      if(storeData.firstPageData.pagination.perPage < storeData.firstPageData.pagination.total){
                        storeData.firstPageData.data.pop();
                      }
                      storeData.key = "currency";
                      delete storeData.otherPageData;
                      this.$store.dispatch("set", storeData);
                    }
                    this.$router.push({
                      name: "currency",
                      // params: { add: true }
                    });
                  }
                } else {
                  this.loading = false;
                }
              }
            }
          );
        }
      });
    }
  }
};
</script>

